// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Header/Header.css */

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    height: 10vh;
    padding: 2rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.logo {
    height: 3.25rem;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 2rem; /* Add space between elements */
}


/* File upload section */
.file-upload-section {
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;
}

.file-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.file-icon:hover {
    transform: scale(1.25);
}


.file-upl {
    font-size: 0.85rem;
    color: #666;
    margin-right: 0.5rem;
    margin-left: -1rem;
}

/* Profile icon styling */
.pro-icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border-radius: 50%;
}

.pro-icon:hover {
    transform: scale(1.25);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.688);
}

/* Add this to the Header.css file */
.reports-link {
    text-decoration: none;
    margin-right: 20px;
}

.reports-button {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    background-color: #EF6F53;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reports-button:hover {
    background-color: #ff6b6b;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.reports-button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reports-button i {
    font-size: 16px;
}

`, "",{"version":3,"sources":["webpack://./src/components/routes/Header/Header.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,+BAA+B;AAC9C;;;AAGA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA,oCAAoC;AACpC;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* src/components/routes/Header/Header.css */\n\n.header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    height: 10vh;\n    padding: 2rem;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.logo {\n    height: 3.25rem;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 2rem; /* Add space between elements */\n}\n\n\n/* File upload section */\n.file-upload-section {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    position: relative;\n}\n\n.file-icon {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.file-icon:hover {\n    transform: scale(1.25);\n}\n\n\n.file-upl {\n    font-size: 0.85rem;\n    color: #666;\n    margin-right: 0.5rem;\n    margin-left: -1rem;\n}\n\n/* Profile icon styling */\n.pro-icon {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    border-radius: 50%;\n}\n\n.pro-icon:hover {\n    transform: scale(1.25);\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.688);\n}\n\n/* Add this to the Header.css file */\n.reports-link {\n    text-decoration: none;\n    margin-right: 20px;\n}\n\n.reports-button {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 5px 10px;\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.reports-button:hover {\n    background-color: #ff6b6b;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\n}\n\n.reports-button:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.reports-button i {\n    font-size: 16px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
